import { Dispatch, SetStateAction, useCallback } from "react";
import { useTranslation } from "@coworker/locales";
import { departments } from "../../InputPopup/UserFiltersRow/FilterChoiceData";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

interface ListProps {
  filter: string | undefined;
  onSelect: (value: string) => void;
  isAcesAndKing: boolean;
  area: string;
  setArea: Dispatch<SetStateAction<string>>;
}

export function HFBList({
  filter,
  onSelect,
  isAcesAndKing,
  area,
  setArea,
}: ListProps) {
  const { t } = useTranslation();

  const displayTextIncludesFilter = useCallback(
    ({ hfbNumber }: { hfbNumber: string }) => {
      if (!filter) return true;
      const displayText = `HFB${hfbNumber} - ${t(`hfb${hfbNumber}String`)}`;
      return displayText.toLowerCase().includes(filter.toLowerCase());
    },
    [filter, t]
  );

  return (
    <FixaListView id="hfb-list">
      {isAcesAndKing &&
        displayTextIncludesFilter({ hfbNumber: "whole=whole" }) && (
          <FixaListViewItem
            title={t("wholeStoreString")}
            control="radiobutton"
            inset
            onChange={() => {
              setArea("whole=whole");
              onSelect("whole=whole");
            }}
            controlProps={{
              checked: area === "whole=whole",
              value: "whole=whole",
            }}
          />
        )}
      {departments.filter(displayTextIncludesFilter).map(({ type, name }) => (
        <FixaListViewItem
          data-testid={`hfb-list-element-${type}`}
          title={name}
          key={type}
          control="radiobutton"
          inset
          onChange={() => {
            setArea(type);
            onSelect(type);
          }}
          controlProps={{
            checked: type === area,
            value: type,
          }}
        />
      ))}
    </FixaListView>
  );
}
